import React, { useEffect, useState } from "react";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import A55ChannelPopup from "./A55ChannelPopup";
import "./MessageA55.css";

const MessageA55 = ({ item }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showAllChannels, setShowAllChannels] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  if (!item?.text_data) return null;

  const {
    channelList,
    channelCount,
    deviceHolding,
    planName,
    planPrice,
    nextAutoPay,
    expiredOn,
  } = item?.text_data;

  const channels = Array.isArray(channelList) ? channelList : [];

  const planCard = (
    <div
      className={`a55-card ${isVisible ? "a55-animate" : ""}${
        nextAutoPay && !expiredOn ? " a55-card--with-autopay" : ""
      }${expiredOn ? " a55-card--expired" : ""}`}
    >
        {expiredOn && (
          <div className="a55-expired-badge">Expired on {expiredOn}</div>
        )}

        {/* Header */}
        <div className="a55-header">
          <span className="a55-title">Your current plan</span>
          <span className="a55-price">₹{planPrice}/month</span>
        </div>

        <div className="a55-watch-on">
          <span className="a55-watch-icons" aria-hidden="true">
            <DesktopWindowsOutlinedIcon />
            <PhoneAndroidOutlinedIcon />
          </span>
          <span>Enjoy Watching on TV and Mobile</span>
        </div>

        {/* Body */}
        <div className="a55-body">
          {/* Channels Section */}
          <div className="a55-section">
            <div className="a55-count">{channelCount}</div>
            <div className="a55-label">TV Channels</div>

            <div className="a55-channels">
              {channels.slice(0, 3).map((channel, index) => (
                <img
                  key={`${channel?.channelName || "channel"}-${index}`}
                  src={channel?.imageLink}
                  alt={channel?.channelName || "Channel"}
                  title={channel?.channelName}
                />
              ))}
              {channels.length > 3 && (
                <button
                  type="button"
                  className="a55-more"
                  onClick={() => setShowAllChannels(true)}
                >
                  &amp; more
                </button>
              )}
            </div>
          </div>

          {/* Divider */}
          <div className="a55-divider" />

          {/* Device Section */}
          <div className="a55-section">
            <div className="a55-count">{deviceHolding}</div>
            <div className="a55-label">Device at a time</div>
          </div>
        </div>

        {/* Footer */}
        <div className="a55-plan-name">{planName}</div>
    </div>
  );

  return (
    <>
      {expiredOn ? (
        <>
          <div className="a55-expired-heading">
            <span className="a55-expired-icon" aria-hidden="true">
              <CalendarMonthOutlinedIcon />
              <ErrorRoundedIcon className="a55-expired-alert" />
            </span>
            <span>Looks like your Plan has expired.</span>
          </div>
          {planCard}
        </>
      ) : (
        planCard
      )}

      {nextAutoPay && !expiredOn && (
        <div className="a55-next-autopay">
          <span className="a55-rupee-icon" aria-hidden="true">
            ₹
          </span>
          <span>
            Your next autopay is scheduled for <strong>{nextAutoPay}</strong>
          </span>
        </div>
      )}

      {showAllChannels && (
        <A55ChannelPopup
          channels={channels}
          onClose={() => setShowAllChannels(false)}
        />
      )}
    </>
  );
};

export default MessageA55;
